var webpackThen = typeof Symbol === "function" ? Symbol("webpack then") : "__webpack_then__";
var webpackExports = typeof Symbol === "function" ? Symbol("webpack exports") : "__webpack_exports__";
var webpackError = typeof Symbol === "function" ? Symbol("webpack error") : "__webpack_error__";
var completeQueue = function(queue) {
	if(queue) {
		queue.forEach(function(fn) { fn.r--; });
		queue.forEach(function(fn) { fn.r-- ? fn.r++ : fn(); });
	}
}
var completeFunction = function(fn) { !--fn.r && fn(); };
var queueFunction = function(queue, fn) { queue ? queue.push(fn) : completeFunction(fn); };
var wrapDeps = function(deps) { return deps.map(function(dep) {
	if(dep !== null && typeof dep === "object") {
		if(dep[webpackThen]) return dep;
		if(dep.then) {
			var queue = [];
			dep.then(function(r) {
				obj[webpackExports] = r;
				completeQueue(queue);
				queue = 0;
			}, function(e) {
				obj[webpackError] = e;
				completeQueue(queue);
				queue = 0;
			});
			var obj = {};
			obj[webpackThen] = function(fn, reject) { queueFunction(queue, fn), dep['catch'](reject); };
			return obj;
		}
	}
	var ret = {};
	ret[webpackThen] = function(fn) { completeFunction(fn); };
	ret[webpackExports] = dep;
	return ret;
}); };
__webpack_require__.a = function(module, body, hasAwait) {
	var queue = hasAwait && [];
	var exports = module.exports;
	var currentDeps;
	var outerResolve;
	var reject;
	var isEvaluating = true;
	var nested = false;
	var whenAll = function(deps, onResolve, onReject) {
		if (nested) return;
		nested = true;
		onResolve.r += deps.length;
		deps.map(function(dep, i) { dep[webpackThen](onResolve, onReject); });
		nested = false;
	};
	var promise = new Promise(function(resolve, rej) {
		reject = rej;
		outerResolve = function() { resolve(exports), completeQueue(queue), queue = 0; };
	});
	promise[webpackExports] = exports;
	promise[webpackThen] = function(fn, rejectFn) {
		if (isEvaluating) { return completeFunction(fn); }
		if (currentDeps) whenAll(currentDeps, fn, rejectFn);
		queueFunction(queue, fn);
		promise['catch'](rejectFn);
	};
	module.exports = promise;
	body(function(deps) {
		currentDeps = wrapDeps(deps);
		var fn;
		var getResult = function() { return currentDeps.map(function(d) {
			if(d[webpackError]) throw d[webpackError];
			return d[webpackExports];
		}); }
		var promise = new Promise(function(resolve, reject) {
			fn = function() { resolve(getResult); };
			fn.r = 0;
			whenAll(currentDeps, fn, reject);
		});
		return fn.r ? promise : getResult();
	}, function(err) { err && reject(promise[webpackError] = err), outerResolve(); });
	isEvaluating = false;
};